import { Button } from '@montugroup/design-system';
import ErrorIcon from '@mui/icons-material/Error';
import { Box, CssBaseline, ThemeProvider, Typography } from '@mui/material';
import { useErrorBoundary } from 'react-error-boundary';

import type { ReactElement } from 'react';
import theme from '../../theme';

export const BadRequestPage = (): ReactElement => {
  const { resetBoundary } = useErrorBoundary();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box role="alert" display="flex" justifyContent="center" alignItems="center" mt={30}>
        <Box textAlign="center">
          <ErrorIcon color="error" sx={{ fontSize: 60 }} />
          <Typography variant="h4" component="h1">
            Bad request.
          </Typography>
          <Typography my={2}>Cannot cancel due to request having incorrect parameters. Please try again.</Typography>
          <Button onClick={resetBoundary}>Reload</Button>
        </Box>
      </Box>
    </ThemeProvider>
  );
};
